export default "<div class=\"widget\">\n    <app-assignee-general-documents [assignee]=\"assignee\"></app-assignee-general-documents>\n</div>\n"